import { render, staticRenderFns } from "./goodsInventory.vue?vue&type=template&id=3e206259&scoped=true"
import script from "./goodsInventory.vue?vue&type=script&lang=js"
export * from "./goodsInventory.vue?vue&type=script&lang=js"
import style0 from "./goodsInventory.vue?vue&type=style&index=0&id=3e206259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e206259",
  null
  
)

export default component.exports